import React, { useState } from "react";
import "./Login.scss";
import EmailForm, { EmailFormData } from "./components/EmailForm/EmailForm";
import OTPForm from "./components/OTPForm/OTPForm";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../components/Toaster/Toaster";
import { axiosApiCall } from "../../utils/axiosHelper";
import { signInUser } from "../../utils/authService";

const Login: React.FC = () => {
  const [step, setStep] = useState<"email" | "otp">("email");
  const [email, setEmail] = useState<string>("");
  const navigate = useNavigate();
  const [otpExpiredTime, setOtpExpiredTime] = useState<string>("");
  const [loadingEmail, setLoadingEmail] = useState<boolean>(false);
  const [loadingOTP, setLoadingOTP] = useState<boolean>(false);
  const [invalidOtp, setInvalidOtp] = useState(false)

  const handleEmailSubmit = async (submittedData: Partial<EmailFormData>) => {
    localStorage.setItem("email", submittedData.email || "");
    setLoadingEmail(true);
    if (submittedData?.email)
      setEmail(submittedData.email)
    try {
      const requestOtpResponse = await axiosApiCall(
        "/auth/request-otp",
        "POST",
        {
          firstName: submittedData.firstName,
          lastName: submittedData.lastName,
          email: submittedData.email,
          ...(submittedData.reCaptchaToken && {
            reCaptchaToken: submittedData.reCaptchaToken,
          }),
          fromOnboardingAssistant: true
        },
        {
          requireAuth: false,
        }
      );
      if (requestOtpResponse?.statusCode !== 200) {
        showToast(requestOtpResponse?.body.message, "error");
        return;
      }
      setInvalidOtp(false)
      setOtpExpiredTime(requestOtpResponse?.body.otp.expiresAt);
      showToast(requestOtpResponse?.body.message, "success");

      setStep("otp");
    } catch (err: any) {
      showToast(`${err?.response?.data?.message || err.message}`, "error");
    } finally {
      setLoadingEmail(false);
    }
  };

  const handleResendOtp = async () => {
    setOtpExpiredTime("");
    setInvalidOtp(false)
    const email = localStorage.getItem("email");
    if (!email) {
      return;
    }
    await handleEmailSubmit({
      email: email,
    });
  };

  const handleSendOTP = async (data: string) => {
    console.log("DATA:", data);

    const email = localStorage.getItem("email") ?? "";
    setLoadingOTP(true);
    setInvalidOtp(false)
    try {
      const verifyOTPResponse = await axiosApiCall(
        "/auth/verify-otp",
        "POST",
        {
          email: email,
          otp: data,
        },
        {
          requireAuth: false,
        }
      );
      if (verifyOTPResponse?.statusCode !== 200) {
        const msg = verifyOTPResponse?.body.message
        if (msg !== 'Invalid OTP') {
          showToast(verifyOTPResponse?.body.message, "error");
        }
        return;
      }
      if (verifyOTPResponse.statusCode === 200) {
        await signInUser({
          username: email,
          password: data
        })
        navigate("/");
      }
    } catch (err: any) {
      console.log(err);
      setInvalidOtp(true)
      const msg = err?.response?.data?.error
      if (msg !== 'Invalid OTP') {
        showToast(
          `${err?.response.data.error || err?.response?.data?.message || err.message
          }`,
          "error"
        );
      }
    } finally {
      setLoadingOTP(false);
    }
  };

  return (
    <div className={`form-wrapper ${step === "otp" ? "slide-up" : ""}`}>
      {step === "email" ? (
        <EmailForm onSubmit={handleEmailSubmit} loading={loadingEmail} />
      ) : (
        <OTPForm
          email={email}
          onResendOtp={handleResendOtp}
          onContinue={handleSendOTP}
          otpExpiredTime={otpExpiredTime}
          loading={loadingOTP}
          invalidOtp={invalidOtp}
        />
      )}
    </div>
  );
};

export default Login;
